





















































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import VarietyGrowthSearch from '@/app/components/VarietyGrowth/VarietyGrowthSearch.vue'
import VarietyGrowthListHeader from '@/app/components/VarietyGrowth/VarietyGrowthListHeader.vue'
import VarietyGrowthList from '@/app/components/VarietyGrowth/VarietyGrowthList.vue'
import Pagination from '@/app/components/Common/Pagination.vue'
/* api */
import VarietyGrowthListApi from '@/app/model/api/varietyGrowthListApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    VarietyGrowthSearch,
    VarietyGrowthListHeader,
    VarietyGrowthList,
    Pagination
  }
})
export default class varietyGrowth extends Vue {
  private totalCount: number = 0
  private currentPage: number = 1
  private notDataMessage: boolean = false
  private showList: boolean = false
  private showLoading: boolean = true
  private complateMessage: string = this.$store.state.alertState.message
  private varietyGrowthData: any = {}
  private isRequesting: boolean = false

  created () {
    this.getVarietyList()
  }

  private getVarietyList () {
    (async () => {
      this.isRequesting = true
      /* 初期表示は名前の昇順 */
      const data = {
        word: this.$store.state.varietyGrowthState.searchText,
        order_name: this.$store.state.varietyGrowthState.orderName,
        sort: this.$store.state.varietyGrowthState.sortAsc,
        page: this.$store.state.varietyGrowthState.currentPage
      }
      this.currentPage = this.$store.state.varietyGrowthState.currentPage

      const result = await VarietyGrowthListApi.getVarietyGrowthList(data)

      if (result.isOk()) {
        this.varietyGrowthData = result.getPayload().results
        this.totalCount = result.getPayload().total_count

        if (this.totalCount === 0) {
          this.notDataMessage = true
        } else {
          this.notDataMessage = false
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
      this.isRequesting = false
    })()
  }

  private doVarietyGrowthSort (data: string) {
    this.isRequesting = true
    this.showLoading = true
    this.scrollTop()

    let sort = false
    if (data === this.$store.state.varietyGrowthState.orderName) {
      if (this.$store.state.varietyGrowthState.sortAsc === true) {
        sort = false
      } else {
        sort = true
      }
    } else {
      sort = true
    }
    /* 1ページ目に戻る */
    const pagination: any = this.$refs.pagination
    pagination.resetCurrentPage()

    this.$store.commit('varietyGrowthState/setCurrentPage', 1)
    this.$store.commit('varietyGrowthState/setOrderName', data)
    this.$store.commit('varietyGrowthState/setSortAsc', sort)
    this.getVarietyList()
  }

  private changeList () {
    /* 1ページ目に戻る */
    const pagination: any = this.$refs.pagination
    pagination.resetCurrentPage()

    this.isRequesting = true
    this.showLoading = true
    this.$store.commit('varietyGrowthState/setCurrentPage', 1)
    this.$store.commit('varietyGrowthState/setOrderName', 'created_at')
    this.$store.commit('varietyGrowthState/setSortAsc', false)
    this.scrollTop()
    this.getVarietyList()
  }

  private onPageChange (page: number) {
    if (!this.isRequesting) {
      this.showLoading = true
      this.scrollTop()
      this.$store.commit('varietyGrowthState/setCurrentPage', page)
      this.getVarietyList()
    }
  }

  private scrollTop () : any {
    let varietyArea: any = document.getElementById('listContainer')!
    varietyArea.scrollTop = 0
  }
}
